<template>
    <b-modal
        modal-class="activeSentRequestsModal"
        body-class="p-0"
        ref="activeSentRequestsModal"
        cancel-variant="outline-secondary"
        size="xl"
        centered
        hide-header
        :title="$t('Page(SentRequest):Component(Label):page-label')"
        hide-footer
    >
        <ForwardedRequests
            ref="sentRequests"
        >
            <template #header-controls>
                <Button class="ml-1" @click="$refs.activeSentRequestsModal.hide()">
                    {{ $t('Component(Button):close') }}
                </Button>
            </template>
        </ForwardedRequests>
    </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import ForwardedRequests from "@/views/request/received/flow/components/vertiacal-steps/ForwardedRequests";
import {Button} from "@core/components/common";

export default {
    components: {BModal, ForwardedRequests: ForwardedRequests, Button},
    methods: {
        show(fetchRequestsPromise) {
            this.$refs.activeSentRequestsModal.show();
            fetchRequestsPromise.then((requests) => {
                this.$refs.sentRequests.renderRequests(requests);
            });
        },
    }
}
</script>

<style lang="scss">
.activeSentRequestsModal .card {
    margin-bottom: 0;
}
</style>
